var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHi2Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_20745_637)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_20745_637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_20745_637",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2C23.5601 2 27.0402 3.05568 30.0003 5.03355C32.9604 7.01141 35.2675 9.82263 36.6298 13.1117C37.9922 16.4008 38.3487 20.02 37.6541 23.5116C36.9596 27.0033 35.2453 30.2106 32.7279 32.7279L20 20V2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 2C23.5601 2 27.0402 3.05568 30.0003 5.03355C32.9604 7.01141 35.2675 9.82263 36.6298 13.1117C37.9922 16.4008 38.3487 20.02 37.6541 23.5116C36.9596 27.0033 35.2453 30.2106 32.7279 32.7279L20 20V2Z",
    fill: "#FF0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2C23.5601 2 27.0402 3.05568 30.0003 5.03355C32.9604 7.01141 35.2675 9.82263 36.6298 13.1117C37.9922 16.4008 38.3487 20.02 37.6541 23.5116C36.9596 27.0033 35.2453 30.2106 32.7279 32.7279L20 20V2Z",
    stroke: "url(#paint0_radial_20745_637)",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_20745_637)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_20745_637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_20745_637",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7279 32.7279C30.7756 34.6802 28.4004 36.1573 25.7859 37.0447C23.1715 37.9322 20.3879 38.2064 17.6505 37.846C14.9132 37.4856 12.2954 36.5004 9.99974 34.9665C7.70407 33.4325 5.79203 31.3911 4.41154 29L20 20L32.7279 32.7279Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.7279 32.7279C30.7756 34.6802 28.4004 36.1573 25.7859 37.0447C23.1715 37.9322 20.3879 38.2064 17.6505 37.846C14.9132 37.4856 12.2954 36.5004 9.99974 34.9665C7.70407 33.4325 5.79203 31.3911 4.41154 29L20 20L32.7279 32.7279Z",
    fill: "#FFA300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7279 32.7279C30.7756 34.6802 28.4004 36.1573 25.7859 37.0447C23.1715 37.9322 20.3879 38.2064 17.6505 37.846C14.9132 37.4856 12.2954 36.5004 9.99974 34.9665C7.70407 33.4325 5.79203 31.3911 4.41154 29L20 20L32.7279 32.7279Z",
    stroke: "url(#paint1_radial_20745_637)",
    strokeWidth: 2,
    mask: "url(#path-3-inside-2_20745_637)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_20745_637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_20745_637",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41154 29C2.43034 25.5684 1.63679 21.579 2.15399 17.6505C2.67119 13.722 4.47023 10.0739 7.27208 7.27208L20 20L4.41154 29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.41154 29C2.43034 25.5684 1.63679 21.579 2.15399 17.6505C2.67119 13.722 4.47023 10.0739 7.27208 7.27208L20 20L4.41154 29Z",
    fill: "#FF6300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41154 29C2.43034 25.5684 1.63679 21.579 2.15399 17.6505C2.67119 13.722 4.47023 10.0739 7.27208 7.27208L20 20L4.41154 29Z",
    stroke: "url(#paint2_radial_20745_637)",
    strokeWidth: 2,
    mask: "url(#path-4-inside-3_20745_637)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_20745_637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4_20745_637",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27208 7.27208C8.94353 5.60062 10.9278 4.27475 13.1117 3.37017C15.2956 2.46558 17.6362 2 20 2V20L7.27208 7.27208Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.27208 7.27208C8.94353 5.60062 10.9278 4.27475 13.1117 3.37017C15.2956 2.46558 17.6362 2 20 2V20L7.27208 7.27208Z",
    fill: "#FF4200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27208 7.27208C8.94353 5.60062 10.9278 4.27475 13.1117 3.37017C15.2956 2.46558 17.6362 2 20 2V20L7.27208 7.27208Z",
    stroke: "url(#paint3_radial_20745_637)",
    strokeWidth: 2,
    mask: "url(#path-5-inside-4_20745_637)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_20745_637)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint4_linear_20745_637)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint5_radial_20745_637)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6606 43H21.3394C20.734 43 20.348 42.3537 20.635 41.8207L26.2956 31.3081C26.5977 30.7472 27.4023 30.7472 27.7044 31.3081L33.365 41.8207C33.652 42.3537 33.266 43 32.6606 43Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6606 42H23.3394C22.734 42 22.348 41.3537 22.635 40.8207L28.2956 30.3081C28.5977 29.7472 29.4023 29.7472 29.7044 30.3081L35.365 40.8207C35.652 41.3537 35.266 42 34.6606 42Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3394 31L47.6606 31C48.266 31 48.652 31.6463 48.365 32.1793L42.7044 42.6919C42.4023 43.2528 41.5977 43.2528 41.2956 42.6919L35.635 32.1793C35.348 31.6463 35.734 31 36.3394 31Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3394 30L48.6606 30C49.266 30 49.652 30.6463 49.365 31.1793L43.7044 41.6919C43.4023 42.2528 42.5977 42.2528 42.2956 41.6919L36.635 31.1793C36.348 30.6463 36.734 30 37.3394 30Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_20745_637)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "url(#paint6_radial_20745_637)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "url(#paint7_radial_20745_637)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "url(#paint8_radial_20745_637)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_20745_637",
    x: 12,
    y: 12,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_20745_637",
    x: 16,
    y: -2,
    width: 26,
    height: 38.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_20745_637",
    x: 0.411621,
    y: 16,
    width: 36.3164,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_20745_637",
    x: -2,
    y: 3.27209,
    width: 26,
    height: 29.7279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_20745_637",
    x: 3.27197,
    y: -2,
    width: 20.728,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_20745_637",
    x: 8,
    y: 8,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_20745_637",
    x: 12,
    y: 12,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5 11) rotate(81.4692) scale(10.1119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 15.5) rotate(96.3402) scale(18.1108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1 15.5) rotate(77.4712) scale(9.21954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.5 5) rotate(-116.565) scale(5.59017 22.4721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20745_637",
    x1: 16,
    y1: 16,
    x2: 36,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) scale(40)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1111 42.1111) rotate(6.1155) scale(15.6446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2222 23.2222) rotate(135) scale(7.07107 31.2574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_20745_637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.3333 22.6667) rotate(150.524) scale(58.7104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHi2Logo);
export default __webpack_public_path__ + "static/media/hi2Logo.def078fcb1f06751879feb0a7c9b4030.svg";
export { ForwardRef as ReactComponent };